export const LOAD_MYAPCIA_START = 'LOAD_MYAPCIA_START';
export const LOAD_MYAPCIA_FAILURE = 'LOAD_MYAPCIA_FAILURE';
export const LOAD_MYAPCIA_SUCCESS = 'LOAD_MYAPCIA_SUCCESS';
export const LOAD_MYAPCIA_ERROR = 'LOAD_MYAPCIA_ERROR';
